import { ViewModel,View, ViewModelMessage } from "binder"
import  { GridLocationSpecifierView } from "./gridLocationSpecifier-view"
import { GridViewModel } from "../grid-viewModel";
import { DragDropPossibilityChecker, DropAppliedViewModelMessage } from "uicomponents";

export class GridLocationSpecifierViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this._typedParent = <GridViewModel>parentViewModel;
    }
    GetDefaultView(): View <ViewModel> {
        return new GridLocationSpecifierView();
    }
    public getTypeId(): string {
        return "VM-F999AF31-C07B-471C-BFF2-BDF37DCF11B8"
    }
    private _typedParent : GridViewModel;
    public set column(v: number) { this._column = v; } public get column(): number { return this._column;} private _column: number;
    public set row(v: number) { this._row = v; } public get row(): number { return this._row;} private _row: number;
    public set isOver(v: boolean) { this._isOver = v; } public get isOver(): boolean { return this._isOver;} private _isOver: boolean;

    public IsMourseOver(clientX:number,clientY:number):boolean{
        return false;
    }
}
